
// A missing key turns its stats off: Universal Analytics died in July 2023 (the visits are
// now counted by the Cloudflare beacon of the pages), the stats server is shut down.
export default {

    //googleId:      'UA-19414637-16'

    //localUrl:     'http://localhost:8081/collect',
    //productionUrl: 'https://compute-it-stats.toxicode.fr/collect'

    //localUrl:      'http://localhost:8081/compute-it/collect',
    //productionUrl: 'http://explorers8.toxicode.fr:8081/compute-it/collect'
}

